export default function toggleClasses (toggleClass, classList, force) {
  const level = classList.indexOf(toggleClass)
  const removeClassList = classList.slice(0, level)
  removeClassList.map((className) => document.body.classList.remove(className))
  document.body.classList.toggle(toggleClass, force)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/vue/src/shared/toggle-classes.js
// module id = eFCi
// module chunks = 0